export default {"src":"/_next/static/media/Vector-Dots.10cfa72e.svg","height":133,"width":241,"blurWidth":0,"blurHeight":0};